import React from "react";
import { Helmet } from "react-helmet";
import MainImage from "../../assets/MainImage.jpg";
import Footer from "../../components/Footer";
import SecondImage from "../../assets/AboutImage4.jpg";
import NavLite from "../../components/NavLite";
import PastWord from "../../components/PastWord";
import SmallTestimony from "../../components/SmallTestimony";

function FortWorth() {
  return (
    <section>
      <Helmet>
        <title>Premium Web Design & SEO for Women-Led Brands in Fort Worth | Zilker Web Design</title>
        <meta
          name="description"
          content="We create bold, high-converting websites and SEO strategies for Fort Worth’s women entrepreneurs. Build authority, drive traffic, and grow your impact."
        />
        <meta
          name="keywords"
          content="fort worth web design for women entrepreneurs, fort worth seo for women-led startups, high-end website design fort worth, premium branding and design fort worth, custom websites for coaches fort worth, seo expert for female founders fort worth, conversion rate optimization fort worth tx, all-in-one digital authority fort worth, web services for premium consultants fort worth, cro strategy for women in business fort worth, fort worth personal brand web design, authority building websites fort worth, fort worth women-led business marketing, content marketing strategy fort worth women, lead generation websites fort worth tx, digital presence for women entrepreneurs fort worth, niche seo for service providers fort worth, web design for high-ticket offers fort worth, seo and branding package fort worth, thought leadership website design fort worth, fort worth authority web launchpad, custom site design for fort worth coaches, website strategy for women founders fort worth, expert web development fort worth tx, premium online presence fort worth women, seo services fort worth, local seo agency texas, niche seo for consultants, expert seo for coaches, texas seo consultant, google business profile seo texas, seo keyword research services, fort worth link building services, seo for service businesses texas, female entrepreneur seo fort worth, technical seo expert fort worth, seo agency for small business, seo for personal brands texas, organic seo services texas, fort worth seo campaign management, seo lead generation fort worth, online visibility services fort worth, targeted seo strategies texas, seo for niche industries, fort worth digital footprint growth, seo services for creatives texas, top-ranking seo agency fort worth, seo for women-owned brands texas, local business seo optimization fort worth, female founder seo fort worth, female founder seo fort worth"
        />
      </Helmet>

      {/* Hero Section */}
      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%",
        }}
      >
        <NavLite />
        <div className="p-10">
          <h2 className="text-3xl font-bold uppercase text-black mb-4 text-center">
            <span className="bg-[#CFF098] italic">
              Fort Worth Web Design & SEO for Women Entrepreneurs
            </span>
          </h2>
        </div>
      </div>

      {/* CTA Section */}
      <div className="mx-auto w-full max-w-7xl px-5 py-6 md:px-10 md:py-10 flex flex-col items-center text-center">
        <p className="text-gray-200 mb-4 text-2xl max-w-2xl">
          Based in Fort Worth? We build stunning websites and data-driven SEO strategies to help women entrepreneurs grow their businesses with confidence.
        </p>
        <a href="https://cal.com/woaomwebdesign/15min">
          <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
            BOOK A FREE STRATEGY CALL →
          </button>
        </a>
      </div>





     {/* Our Process */}
<div className="mx-auto w-full max-w-7xl flex flex-col items-center text-center mt-20">
  <h2 className="text-3xl font-medium md:text-4xl text-white uppercase">
    Our Process
  </h2>
</div>

{/* Centered Paragraph below heading */}
<p className="mx-auto mt-4 max-w-3xl text-sm text-gray-200 sm:text-base md:mb-12 lg:mb-16 text-center">
  We work closely with Fort Worth women entrepreneurs to craft websites that tell your story and attract your perfect clients.
</p>

<div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-12">
  {/* Text Section */}
  <div className="flex flex-col justify-center w-full md:w-1/2">
    {[
      {
        step: 1,
        title: "Initial Consultation",
        desc: "Exploring your Fort Worth business goals and brand identity to lay the groundwork.",
      },
      {
        step: 2,
        title: "Creative Design",
        desc: "Designing a visually compelling, mobile-friendly website tailored to your clients.",
      },
      {
        step: 3,
        title: "Fort Worth SEO Strategy",
        desc: "Implementing SEO techniques focused on Fort Worth to maximize your reach.",
      },
      {
        step: 4,
        title: "Launch & Growth",
        desc: "Launching your site and continuing SEO optimization to grow your impact steadily.",
      },
    ].map(({ step, title, desc }) => (
      <div key={step} className="mb-8 flex max-w-lg justify-center gap-4 px-6 py-5 text-black">
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-gray-100">
          <p className="text-sm font-bold sm:text-base">{step}</p>
        </div>
        <div className="ml-4 flex flex-col gap-2">
          <h5 className="text-xl font-medium uppercase text-white">{title}</h5>
          <p className="text-sm text-gray-200">{desc}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Image Section */}
  <div className="w-full md:w-1/2 flex items-stretch">
    <img
      alt="Website Design for Women Entrepreneurs Fort Worth"
      src={MainImage}
      className="w-full object-cover"
    />
  </div>
</div>






      {/* Past Work & Testimonials */}
      <PastWord />
      <SmallTestimony />

      {/* About Us Section */}
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[600px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-sm uppercase mb-12">ABOUT US</p>
            </div>
            <h4 className="mb-6 text-2xl font-semibold md:text-3xl md:mb-8 uppercase">
              Helping{" "}
              <span className="italic text-black bg-[#CFF098]">
                Fort Worth Women Entrepreneurs
              </span>{" "}
              Show Up Powerfully{" "}
              <span className="italic text-black bg-[#CFF098]">
                Online & in Search.
              </span>
            </h4>
            <p className="text-sm text-white sm:text-xl">
              Our specialty? Building clean, strategic websites and delivering SEO results for women-led businesses in Fort Worth. Whether you're a coach, creative, or consultant, we help you reach the next level.
              <br />
              <br />
              We know the Fort Worth market and what it takes for women to win online. That’s why we tailor everything to fit your voice, goals, and audience.
            </p>
            <p className="mt-6 mb-6 text-xl italic uppercase">
              Your brand deserves to shine.{" "}
              <span className="italic">We’ll help you make it happen.</span>
            </p>

            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="/about"
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60 text-sm"
              >
                <p>LEARN MORE ABOUT US →</p>
              </a>
            </div>
          </div>

          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="Fort Worth women entrepreneur using laptop"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
}

export default FortWorth;
